/**
 * USED BY MEMBERS OF ROLES LOGGED IN TO APP WEBSITE (EXCEPT ADMIN BACK OFFICE BOOKER)
 */
var BookingRequestsDt = function() { //initialise the booking requests datatable

    var _bookingRequestsDt = function( config ) {
        
        // Apply custom style to select
        $.extend( $.fn.dataTableExt.oStdClasses, {
            "sLengthSelect": "custom-select"
        });

        var anchor = config.anchor || '.requests-data-table';
        Debug.log('config',config);
        Debug.log('dataTable',anchor);

        // Basic datatable
        var table = $(anchor).DataTable({
            processing: true,
            serverSide: true,
            searching: false,
            autoWidth: false,
            ajax: config.route,
            drawCallback: function(settings){
                var conf;
                $('.request-details-modal').off().on('shown.bs.modal',function(e){
                    conf = $(e.relatedTarget).data('config');
                    bookableId = conf.uuid;
                    output_tz = conf.tz;
                    Do.Ajax('/bookable/api/calendar',{
                        bookable:conf.uuid,
                        date: conf.initialDate,
                        tz:conf.tz,
                        sel:conf.selector + '-' + conf.entry,
                        slots:true,
                        entry:conf.entry
                    }); 
                    currentSlot = conf.entry;
                    $('#booking-item-default2-'+conf.entry).on('shown.bs.collapse',function(){
                        handleScheduleModalFooter(conf.entry, true);
                    });
                });
                $('.request-details-modal').on('hide.bs.modal',function(e){
                    $('#booking-item-default1-'+conf.entry).collapse('show');
                    handleScheduleModalFooter(conf.entry,false);
                });
                $('.block-attendee').on('click',function(){
                    var uuid = $(this).data('uuid');
                    Do.Ajax('/business/api/schedule-type/event',{
                        uuid:uuid,
                        event:'cleverlyConfirm',
                        handle:'blockRequester'
                    });
                });
                $('.delete-bookable-request').on('click',function(){
                    var uuid = $(this).data('uuid');
                    Do.Ajax('/business/api/schedule-type/event',{
                        uuid:uuid,
                        event:'cleverlyConfirm',
                        handle:'deleteRequest'
                    });
                });
                $('#button-clever').on('click',function(){
                    Do.Ajax('/business/api/schedule-type/event',{
                        action:$(this).data('action'),
                        event:$(this).data('next'),
                    });
                });
            },
            columnDefs: [
                {
                    className: 'text-right','targets':[4]
                }
            ],
            columns: [
                {
                    data: null,
                    name: '',
                    orderable: false,
                    render: function( data, type, row ){
                        return '<img src="'+data.navatar+'" class="rounded-circle img-fluid" alt="">';
                    }
                },
                {
                    data: null,
                    name: 'name',
                    render: function( data, type, row ){
                        return data.attendee.firstname +' '+ data.attendee.lastname + 
                            '<br><span class="font-size-xs">('+data.attendee.email+'</span>)';
                    }
                },
                {
                    data: null, 
                    name: 'type',
                    render: function( data, type, row ){
                        return data.bookable.name;
                    }
                },
                {
                    data: null,
                    name: 'when',
                    render: function( data, type, row ){
                        return data.when_date + 
                            '<br><span class="font-size-xs">'+data.when_time+'</span>';
                    }
                },
                {data: 'action', name: 'actions', orderable: false, searchable: false},
            ]
        });

        // Resize scrollable table when sidebar width changes
        $('.sidebar-control').on('click', function() {
            table.columns.adjust().draw();
        });

        // $(window).on('resize', function(){
        //     table.columns.adjust().draw();
        // });
    };

    return {
        init: function(c) {
            _bookingRequestsDt(c);
        }
    }

}();

/**
 * USED BY ADMIN BACK OFFICE BOOKER
 */
var AdminBookingRequestsDt = function() { //initialise the booking requests datatable

    var _bookingRequestsDt = function( config ) {
        
        // Apply custom style to select
        $.extend( $.fn.dataTableExt.oStdClasses, {
            "sLengthSelect": "custom-select"
        });

        // Basic datatable
        var table = $('.requests-data-table').DataTable({
            processing: true,
            serverSide: true,
            searching: false,
            autoWidth: false,
            ajax: config.route,
            drawCallback: function(settings){
                var conf;
                $('.request-details-modal').off().on('shown.bs.modal',function(e){
                    conf = $(e.relatedTarget).data('config');
                    bookableId = conf.uuid;
                    output_tz = conf.tz;
                    Do.Ajax('/bookable/api/calendar',{
                        bookable:conf.uuid,
                        date: conf.initialDate,
                        tz:conf.tz,
                        sel:conf.selector + '-' + conf.entry,
                        slots:true,
                        entry:conf.entry
                    }); 
                    currentSlot = conf.entry;
                    $('#booking-item-default2-'+conf.entry).on('shown.bs.collapse',function(){
                        handleScheduleModalFooter(conf.entry, true);
                    });
                });
                $('.request-details-modal').on('hide.bs.modal',function(e){
                    $('#booking-item-default1-'+conf.entry).collapse('show');
                    handleScheduleModalFooter(conf.entry,false);
                });
                $('.block-attendee').on('click',function(){
                    var uuid = $(this).data('uuid');
                    Do.Ajax('/business/api/schedule-type/event',{
                        uuid:uuid,
                        event:'cleverlyConfirm',
                        handle:'blockRequester'
                    });
                });
                $('.delete-bookable-request').on('click',function(){
                    var uuid = $(this).data('uuid');
                    Do.Ajax('/business/api/schedule-type/event',{
                        uuid:uuid,
                        event:'cleverlyConfirm',
                        handle:'deleteRequest'
                    });
                });
                $('#button-clever').on('click',function(){
                    Do.Ajax('/business/api/schedule-type/event',{
                        action:$(this).data('action'),
                        event:$(this).data('next'),
                    });
                });
            },
            columnDefs: [
                {
                    className: 'text-right','targets':[4]
                }
            ],
            columns: [
                {
                    data: null,
                    name: '',
                    orderable: false,
                    render: function( data, type, row ){
                        return '<img src="'+data.navatar+'" class="rounded-circle img-fluid" alt="">';
                    }
                },
                {
                    data: null,
                    name: 'name',
                    render: function( data, type, row ){
                        return data.attendee.firstname +' '+ data.attendee.lastname + 
                            '<br><span class="font-size-xs">('+data.attendee.email+'</span>)';
                    }
                },
                {
                    data: null, 
                    name: 'type',
                    render: function( data, type, row ){
                        return data.bookable.name;
                    }
                },
                {
                    data: null,
                    name: 'when',
                    render: function( data, type, row ){
                        return data.when_date + 
                            '<br><span class="font-size-xs">'+data.when_time+'</span>';
                    }
                },
                {data: 'action', name: 'actions', orderable: false, searchable: false},
            ]
        });

        // Resize scrollable table when sidebar width changes
        $('.sidebar-control').on('click', function() {
            table.columns.adjust().draw();
        });

        // $(window).on('resize', function(){
        //     table.columns.adjust().draw();
        // });
    };

    return {
        init: function(c) {
            _bookingRequestsDt(c);
        }
    }

}();

var Booker = function(){

    var _init = function(config){
    
        $(config.selector).datebox({
            mode: "calbox",
            displayMode:'inline',
            afterToday:true,
            openButton:false,
            useTodayButton:true,
            defaultValue:config.defaultValue,
            minDate:config.minDate,
            maxDate:config.maxDate,
            blackDays:config.blackDays,
            hideInput:true,
            controlWidth:'100%;',
            disableWheel:true,
            calSelectedOutOfBounds:false,
            theme_inlineContainer:'bg-white border border-secondary rounded shadow mb-4 p-2',
            theme_headerTheme:'bg-secondary align-self-center pt-2 rounded',
            theme_cancelBtn: ['','outline-none'],
            theme_todayBtn:['enter6','outline-white'],
            theme_cal_Default:'outline-none bg-secondary text-white my-2',
            theme_cal_DateList:'font-weight-bold',
            theme_cal_NextBtn: ['arrow-right32 text-secondary','font-weight-light'],
            theme_cal_PrevBtn: ['arrow-left32 text-secondary','font-weight-light'],
            iconFactory : function ( icnName ) {
                return "<i class=\"icon icon-2x icon-" + icnName + "\"></i>";
            },
        });

        $(config.selector).bind( "datebox", function ( e, passed ) { 
            if ( passed.method === "set" ) {

                // Formatted value is: passed.value; 
                // JavaScript Date object is: passed.date;
                // We only need the value
                Do.Ajax('/bookable/api/event-slots',{
                    uuid:bookableId,
                    host:host,
                    date:passed.value,
                    time:moment().format("HH:mm"),
                    zone:config.attendee_tz || output_tz,
                    entry:config.entry,
                    current:true,
                    auto:(typeof sched == 'undefined' ? false: true)
                }); 

            } 
        });

        if( config.getSlots ==  true ){
            Do.Ajax('/bookable/api/event-slots',{
                uuid:bookableId,
                host:host,
                date:config.defaultValue,
                time:moment().format("HH:mm"),
                zone:config.attendee_tz || output_tz,
                entry:config.entry,
                current:true,
                auto:(typeof sched == 'undefined' ? false: true)
            }); 
        }
    }

    var _paintSlotList = function(response){
        
        var entry = '';
        if( typeof response !='undefined' && 
            typeof response.entry != 'undefined' &&
            response.entry != null ){
            entry = '-'+response.entry;
        }
        $('.booking-slot-req').val('');
        if(typeof response != 'undefined' && typeof response.slots != 'undefined' && response.slots.length){
            $('#slot-list'+entry).html(response.slots);
            $('#slots'+entry).addClass('d-block').removeClass('d-none');
            $('.slot-select-button').off().on('click',function(){
                var uniqid = $(this).data('uniqid');
                $('.slot-select').removeClass('w-50').addClass('w-100');
                $('.slot-confirm').removeClass('w-50 d-block').addClass('w-100 d-none');
                $('#slot_select_'+uniqid).removeClass('w-100').addClass('w-50');
                $('#slot_confirm_'+uniqid)
                    .removeClass('w-100 d-none')
                    .addClass('w-50 d-block');
                $('#medium-confirm-modal').off().on('show.bs.modal',function(){
                    setBookingDatetime( response.date, uniqid )
                })
            });
            if( response.empty ){
                $('#slot-head'+entry).hide();
            }else{
                $('#slot-head-date'+entry).text(response.date);
                $('#slot-head'+entry).show();
                $('.slot-reschedule').on('click',function(){
                    setBookingDatetime( 
                        response.date, 
                        $(this).parent().data('uniqid'), 
                        {
                            hostzone:response.zone,
                            entry:response.entry
                        } 
                    );
                });
            }
        }else{
            $('#slot-list'+entry).empty();
            $('#slots'+entry).addClass('d-none').removeClass('d-block');
        }
    }

    return {
        init: function(config){
            _init(config);
        },
        slots: function(r){
            _paintSlotList(r);
        },
    }

}();

var paintSlots = function(response){ 
    Booker.slots( response );
};

var setBookingDatetime = function( dt_date, uniqid, resched ){

    var el, zone, newVis, newHid, dt;
    el = '#slot_confirm_'+uniqid;
    if( typeof resched == 'undefined' ){
        zone = $('#booking-timezone').find(':selected').val();
    }else{
        zone = output_tz;
    }
    dt = $(el).find('a');
    var dt_tf = dt.data('time-from')+' '+dt.data('time-from-a');
    var dt_tt = dt.data('time-to')+' '+dt.data('time-to-a');
    var dt_tz = zone;
    var dt_confirm = dt_trans;
    dt_confirm = dt_confirm.replace(':date',dt_date);
    dt_confirm = dt_confirm.replace(':from',dt_tf);
    dt_confirm = dt_confirm.replace(':to',dt_tt);
    dt_confirm = dt_confirm.replace(':tz',dt_tz);
    var jslot = {
        date:dt_date,
        from:dt_tf,
        to:dt_tt,
        tz:dt_tz
    };
    if( typeof resched == 'undefined' ){
        newVis = '#booking-date';
        newHid = '#booking-slot-req';
    }else{
        newVis = '#booking-slot-text-'+resched.entry;
        newHid = '#booking-slot-resched-'+resched.entry;
    }
    $(newVis).html(dt_confirm);
    $(newHid).val(JSON.stringify(jslot));

    if( typeof resched != 'undefined' ){
        $('#booking-item-default1-'+resched.entry).collapse('show');
        handleScheduleModalFooter( resched.entry, false );
    }

}

var handleScheduleModalFooter = function( uuid, hide ){
    if( hide ){
        $('#footer-'+uuid).hide();
    }else{
        $('#footer-'+uuid).show();
    }
}


var bookerInit = function( response ){
    Debug.log('resources/promana/js/watch/public/booker.js',response);
    Booker.init(response.config);

    if( typeof z !== 'undefined' ){
        $('#booking-timezone').select2();
        $('#booking-timezone').val(z).trigger('change');
    }
    output_tz = $('#booking-timezone').find(':selected').val()
    
    $('#booking-timezone').on('change',function(){
        output_tz = $('#booking-timezone').find(':selected').val()
        var dtObj = $('#db2').datebox('getTheDate');
        var dtVal = $('#db2').datebox('callFormat', '%Y-%m-%d', dtObj);
        $('#db2').trigger( "datebox", { 
            method:"set", 
            value: dtVal
        });
    });
    
    setTimeout(function(){
        $('#slots').css('max-height',($('.dbContainer_0').height() + $(".tz").height()));
    },100);

}

